import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@snsw-gel/react';

const fmtMSS = s => (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;

const SessionTimeoutModal = ({ open, countdown, onLogout, onContinue, disableContinue }) => {
    const buttons = [ { text: 'Logout', onClick: onLogout } ];

    !disableContinue && buttons.push({ text: 'Continue Session', onClick: onContinue });

    return (
        <>
            {open && (
                <Modal
                    title='Session Timeout'
                    buttons={buttons}
                >
                    <>
                        The current session is about to expire in {fmtMSS(countdown)} minutes.
                        {!disableContinue && <span> Would you like to continue the session?</span>}
                    </>
                </Modal>
            )}
        </>
    );
};

SessionTimeoutModal.displayName = 'SessionTimeoutModal';

SessionTimeoutModal.propTypes = {
    open: PropTypes.bool.isRequired,
    countdown: PropTypes.number.isRequired,
    onLogout: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    disableContinue: PropTypes.bool.isRequired
};

export default memo(SessionTimeoutModal);
